import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getChequesApi,
  getUpdateChequeApi,
  getUpdateChequeExpectedBankApi,
  getIdByChequeApi,
  deleteChequeApi
} from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";
import dayjs from "dayjs";

export const fetchChequeList = createAsyncThunk(
  "cheques/fetchList",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getChequesApi(filters);
      // return res.data.map((row, index) => ({
      //   id: row.id,
      //   no: index + 1,
      //   from_acc: row.from_acc,
      //   voucher_no: row.voucher_no,
      //   cheque_type: row.acc_name,
      //   amount: row.amount,
      //   invoice_date: row.created_date,
      //   payable_date: row.date,
      //   paid_date: row.paid_date,
      //   status: row.status,
      // }));
        return res.data.map((row, index) => ({
        ...row, // 🔑 keep everything (cus_id, voucher_type, rcv_d_id, etc.)
        no: index + 1,
        cheque_type: row.acc_name, // keep friendly alias
        invoice_date: row.created_date,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateChequeStatus = createAsyncThunk(
  "cheques/updateStatus",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await getUpdateChequeApi(payload);

      // ✅ After success, refresh the list like old code did (getCheques)
      const { filters } = getState().cheques;
      dispatch(fetchChequeList(filters));

      return res.data; // only return success message
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateChequeExpectedBank = createAsyncThunk(
  "cheques/updateExpectedBank",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await getUpdateChequeExpectedBankApi(payload);

      const { filters } = getState().cheques;
      dispatch(fetchChequeList(filters));

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchChequeCustomersBySearch = createAsyncThunk(
  "cheques/fetchCustomersBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["debitor", "creditor"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);













































export const fetchChequeAccounts = createAsyncThunk(
  "cheques/fetchAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: ["cash_in_hand", "bank_account"],
      });
      return res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchChequeById = createAsyncThunk(
  "cheques/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getIdByChequeApi({ id });
      const row = res.data && res.data[0] ? res.data[0] : null;
      if (!row) return rejectWithValue("No cheque found");

      // normalize fields the rest of code expects
      return {
        ...row,
        invoice_date: row.created_date,
        cheque_type: row.acc_name,
        cheque_acc_id: row.to_acc_id ?? row.cheque_acc_id ?? null,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteCheque = createAsyncThunk(
  "cheques/deleteCheque",
  async (cheque, { rejectWithValue }) => {
    try {
      const res = await deleteChequeApi( cheque );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

















































































































































